
export function leadingZeros( value:number, numDigits:number = 2 )
{
  if ( numDigits <= 1 )
  {
    return value;
  }
  
  let hasMinus = value < 0;
  let stringValue = Math.abs( value ) + "";
  
  while ( stringValue.length < numDigits )
  {
    stringValue = "0" + stringValue;
  }

  return ( hasMinus ? "-" : "" ) + stringValue;
}